import * as React from 'react';

import { RichTextRenderer } from '~shared/components/RichTextRenderer';

import { useResultQuestionState } from '../ActivityResult/ActivityResultQuestionProvider';

interface Props {
  order?: number;
}

export function ResultsQuestionText({ order }: Props): React.ReactElement {
  const questionContext = useResultQuestionState();
  const { question: { questionText } = {} } = questionContext;
  const showQuestionNumber = !!order;

  return questionText ? (
    <div
      className="grid grid-cols-question-fields max-w-5xl p-0"
      data-quiz-question-text
    >
      {showQuestionNumber ? (
        <div className="flex flex-none items-center justify-center w-12 h-12 font-display text-md font-700 text-blue-900">
          {order}.<span style={{ marginLeft: '-0.25em' }}></span>
        </div>
      ) : null}
      <div
        className={`${
          showQuestionNumber ? 'col-start-2' : 'col-span-2'
        } min-w-0 ml-2`}
      >
        <RichTextRenderer
          className="flex-grow-1 h-auto py-2 font-display text-md font-500 text-blue-900 leading-8 max-h-full min-h-full overflow-auto"
          htmlText={questionText}
        />
      </div>
    </div>
  ) : null;
}
